import React from 'react';

// Components
import { WpText } from '../text';
import { WpIcon } from '../icon';
import { WpButton } from '../button';

// Styles
import './WpPageSideRail.scss';

type Props = {
  title?: string;
  children?: React.ReactNode;
  toggleIsSideRailOpen?: () => void;
};

const WpPageSideRail = ({ title, children, toggleIsSideRailOpen }: Props) => {
  const baseClassName = 'WpPageSideRail';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__title-bar`}>
        {title && (
          <WpText variant="bodyXl" bold noMargin>
            {title}
          </WpText>
        )}
        {toggleIsSideRailOpen && (
          <WpButton onClick={toggleIsSideRailOpen} variant="tertiary">
            <WpIcon name="times" />
          </WpButton>
        )}
      </div>
      {children}
    </div>
  );
};

export default WpPageSideRail;
